import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const VideoTestimonialCard = ({ testimonial, onPlay }) => (
  <article className="card-3d group overflow-hidden">
    <div className="relative aspect-video overflow-hidden bg-black">
      <Image
        src={testimonial?.videoThumbnail}
        alt={`${testimonial?.name} — verified winner on Nitin Online Book`}
        className="h-full w-full bg-black object-contain transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-black/30" />

      <button
        onClick={() => onPlay?.(testimonial)}
        aria-label={`Play ${testimonial?.name}'s story`}
        className="absolute inset-0 m-auto flex h-16 w-16 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110"
        style={{
          background: 'radial-gradient(circle at 34% 28%, #FFF6D0, #F0C24B 52%, #7A5406)',
          boxShadow: '0 1px 0 rgba(255,255,255,0.7) inset, 0 20px 36px -16px rgba(0,0,0,0.95)',
        }}
      >
        <Icon name="Play" size={24} color="#150F02" />
      </button>

      <span className="absolute bottom-3 right-3 rounded-full border border-white/15 bg-black/70 px-2.5 py-0.5 text-[0.65rem] text-white backdrop-blur">
        {testimonial?.playTime}
      </span>

      {testimonial?.verified && (
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-wa-green px-2.5 py-1 text-[0.6rem] font-bold text-[#04220F]">
          <Icon name="BadgeCheck" size={11} color="#04220F" /> VERIFIED
        </span>
      )}
    </div>

    <div className="p-6">
      <div className="flex items-center gap-3">
        <Image src={testimonial?.avatar} alt={testimonial?.name} className="h-11 w-11 rounded-full" />
        <div className="min-w-0 flex-1">
          <h3 className="truncate font-display text-sm font-semibold text-white">{testimonial?.name}</h3>
          <p className="truncate text-xs text-white/45">{testimonial?.location} · {testimonial?.game}</p>
        </div>
        <div className="text-right">
          <p className="font-display text-base font-bold text-wa-green">{testimonial?.winAmount}</p>
          <p className="text-[0.6rem] text-white/35">withdrawn</p>
        </div>
      </div>

      <p className="mt-4 line-clamp-3 text-sm leading-relaxed text-white/55">“{testimonial?.quote}”</p>

      <div className="mt-4 flex items-center justify-between">
        <span className="flex">
          {Array.from({ length: testimonial?.rating ?? 5 }).map((_, i) => (
            <Icon key={i} name="Star" size={13} color="#F0C24B" fill="#F0C24B" />
          ))}
        </span>
        <button
          onClick={() => onPlay?.(testimonial)}
          className="inline-flex items-center gap-1.5 text-xs font-medium text-royal-gold transition hover:gap-2.5"
        >
          Watch story <Icon name="ArrowRight" size={13} />
        </button>
      </div>
    </div>
  </article>
);

export default VideoTestimonialCard;
